<template>
  <RemotePaginatedList :filter-options="filterOptions"
                       :excluded-filter-fields="excludeFilterFields"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="event/session/"
                       data-key="sessions"
                       :extra-params="{event_id: eventId}"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template #item.start="{value}">
      {{ $parseDate(value) }}
    </template>
    <template #item.end="{value}">
      {{ $parseDate(value) }}
    </template>
    <template #item.quota="{value}">
      {{ value === -1 ? 'N/A' : value }}
    </template>
    <template #item.actions="{item}">
      <v-row>
        <v-col>
          <font-awesome-icon icon="edit"
                             @click.stop="editItem(item)"></font-awesome-icon>
        </v-col>
        <v-col>
          <font-awesome-icon icon="trash"
                             @click.stop="deleteItem(item)"></font-awesome-icon>
        </v-col>
      </v-row>
    </template>
  </RemotePaginatedList>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faEdit, faSearch} from '@fortawesome/free-solid-svg-icons'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {computed, onMounted, ref, watch} from "@vue/composition-api";
import _ from 'lodash';

library.add(faEdit, faSearch);

export default {
  name: 'SessionList',
  components: {RemotePaginatedList},
  props: {
    showSelect: Boolean,
    excludeFilterFields: Array,
    refreshTrigger: Boolean,
    eventId: String,
    value: Array,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    });

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_session.name_en'), value: 'name_en', contains: true},
        {text: root.$t('admin_session.name_zh'), value: 'name_zh', contains: true},
        {text: root.$t('admin_session.start'), value: 'start', date_range: true},
        {text: root.$t('admin_session.end'), value: 'end', date_range: true},
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_session.name_en'), value: 'name_en'},
      {text: root.$t('admin_session.name_zh'), value: 'name_zh'},
      {text: root.$t('admin_event.order_no'), value: 'order_no'},
      {text: root.$t('admin_session.start'), value: 'start'},
      {text: root.$t('admin_session.end'), value: 'end'},
      // {text: root.$t('admin_session.time'), value: 'time'},
      {text: root.$t('admin_session.quota'), value: 'quota', sortable: false},

      {text: '', value: 'actions', sortable: false, width: 100},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const editItem = function (item) {
      emit('edit', item);
    };
    const deleteItem = function (item) {
      if (confirm(root.$t('admin_session.delete_msg'))) {
        root.$callAPI('event/session/delete/', {id: item.id}, function () {
          refresh();
        });
      }
    };

    return {
      filterOptions,
      headers,
      innerRefreshTrigger,

      selectedItemIds,

      editItem,
      deleteItem,
    }
  },
}
</script>
